import { HttpMethod } from "../common/lib/fetch/useFetch";
import useRequest, { RequestOptions } from "../common/lib/fetch/useRequest";

interface ReprintAcceptedRequest {
  success: boolean;
}

const useReprintAccepted = (stagedOrderId: string, options?: RequestOptions) =>
  useRequest<ReprintAcceptedRequest>({
    headers: () => Promise.resolve(new Headers()),
    method: HttpMethod.POST,
    path: `/api/developer/stagedOrders/${stagedOrderId}/reprintAccepted`
  }, options);

export default useReprintAccepted;
